import { v4 as uuidv4 } from 'uuid';
import { INoteRecording, IProcessedAIResponse } from '../redux/note/noteSlice';

export function processResponse(processedContent: string): IProcessedAIResponse[] {
  // Remove the surrounding markdown-like syntax if present
  const cleanedContent = processedContent.replace(/```json\s*|\s*```/g, '');

  let jsonObject: { [key: string]: string[] };

  try {
    jsonObject = JSON.parse(cleanedContent);
  } catch (error) {
    return [];
  }

  const processedResponse: IProcessedAIResponse[] = [];
  Object.keys(jsonObject).forEach((key) => {
    const data = jsonObject[key].map((item) => ({
      id: uuidv4(),
      value: item.split(': ')[1],
    }));
    processedResponse.push({
      id: uuidv4(),
      title: key,
      data,
    });
  });

  return processedResponse;
}

export const concatenateTranscriptions = (
  noteRecordings: INoteRecording[],
  noteId: string
): string =>
  noteRecordings
    .filter((noteRecording) => noteRecording.noteId === noteId)
    .map((recording) => recording.transcription)
    .join('. ');
